import RelatedArticlesComponent from "../../../../components/help/RelatedArticlesComponent.tsx";
import {imageMap} from "../../../../images/imageMap.ts";
import {Link} from "react-router-dom";
import QuestionAnswerComponent, {Question} from "../../../../components/help/QuestionAnswerComponent.tsx";
import {WhatConnectionType} from "../../../../components/help/CommonQuestions.tsx";

const questions: Question[] = [
    {
        question: "Fibernet",
        answer: <>
            <h3>
                Zyxel router
            </h3>
            <div className="article">
                <img
                    className="small paragraph-image no-br"
                    src={imageMap.help.equipment.routerZyxelEx}
                    alt="Illustreret Zyxel router"
                />
                <div className="paragraph">
                    <ul className="list list--bullet list--compact">
                        <li><p>
                            Wifi og LAN router.
                        </p></li>
                        <li><p>
                            Trådløst internet.
                        </p></li>
                        <li><p>
                            Understøtter både 2,4&nbsp;GHz og 5&nbsp;GHz.
                        </p></li>
                        <li><p>
                            Fire 1000&nbsp;Mbps-porte.
                        </p></li>
                        <li><p>
                            Modtager internetforbindelsen igennem en 1000&nbsp;Mbps-port.
                        </p></li>
                        <li><p>
                            Kan med sin kraftige CPU levere gigabit forbindelse til hele hjemmet.
                        </p></li>
                        <li><p>
                            Fast offentlig IPv4-adresse og dynamisk IPv4-adresse er muligt via IPv4. På IPv6 tilbyder vi et fast /128 WAN og et fast /48 præfiks. <Link
                            to={"/hjaelp/internet-og-wifi/ip-adresse"}
                            >Læs mere om IP-adresse</Link>.
                        </p></li>
                        <li><p>
                            Mesh-kompatibel.
                        </p></li>
                    </ul>
                </div>
            </div>
        </>
    },
    {
        question: "5G-internet",
        answer: <>
            <h3>
                Zyxel eller Huawei router
            </h3>
            <div className="article">
                <img
                    className="small paragraph-image no-br"
                    src={imageMap.help.equipment.routerZyxelNr5307}
                    alt="Illustreret Zyxel router"
                />
                <div className="paragraph">
                    <ul className="list list--bullet list--compact">
                        <li><p>
                            Wifi og LAN router.
                        </p></li>
                        <li><p>
                            Trådløst internet med 4x4 4G/5G antenner.
                        </p></li>
                        <li><p>
                            Understøtter både 2,4&nbsp;GHz og 5&nbsp;GHz.
                        </p></li>
                        <li><p>
                            Zyxel NR5307 eller Huawei H158-381, alt efter hvad vi har tilgængeligt når du bestiller.
                        </p></li>
                    </ul>
                </div>
            </div>
        </>
    },
    {
        question: "Internet via kabel-tv-stikket",
        answer: <>
            <h3>
                Sagem Fast 3890V3 router
            </h3>
            <div className="article">
                <img
                    className="small paragraph-image no-br"
                    src={imageMap.help.equipment.routerSagemcom3890}
                    alt="Illustreret Sagemcom router"
                />
                <div className="paragraph">
                    <ul className="list list--bullet">
                        <li><p>
                            Trådløst internet med 4x4 802.11ac-teknologi.
                        </p></li>
                        <li><p>
                            Understøtter både 2,4&nbsp;GHz og 5&nbsp;GHz.
                        </p></li>
                        <li><p>
                            Fire 1000&nbsp;Mbps-porte.
                        </p></li>
                        <li><p>
                            Gratis dynamisk IPv4-adresse er muligt &ndash; det er ofte løsningen hvis du oplever problemer med NAT-type i spil. <Link
                            to={"/hjaelp/internet-og-wifi/ip-adresse"}
                            >Læs mere om IP-adresse</Link>.
                        </p></li>
                    </ul>
                </div>
            </div>
        </>
    },
]

export default function HvilkenRouterArticle() {
    return (
        <>
            <article className="help-article-content">
                <div className="article">
                    <div className="text-box text-box--gray">
                        <p>
                            Som kunde hos os låner du en standard router, som dækker de flestes behov.
                            Routeren afhænger af, hvilken forbindelse du køber.
                        </p>
                    </div>
                </div>

                <div className="article">
                    <h2>Routere</h2>
                    <QuestionAnswerComponent questions={[...questions, WhatConnectionType]}/>
                </div>

                <div className="article">
                    <div className="paragraph">
                        <h2>Hvordan modtager jeg mit udstyr?</h2>
                        <p>
                            Vi sender dit udstyr med PostNord til et posthus eller pakkeboks nær din adresse.
                            Du modtager en mail med trackingnummer og information om udstyret, når det er på vej.
                            Når pakken er klar til afhentning, vil du modtage en SMS fra PostNord.
                        </p>
                    </div>
                </div>

                <div className="article">
                    <div className="paragraph">
                        <h2>Hvornår sender i mit udstyr?</h2>
                        <p>
                            Vi sender udstyret 10 dage før du kommer online på din forbindelse.
                            Hvis du kommer online inden for de 10 dage, sender vi udstyret til dig med det samme.
                        </p>
                        <p>
                            Skal du bruge en frontplade til din fiberboks, modtager du den i en separat pakke et par dage før din online dato.
                            Når pakken er afsendt, får du en mail og sms med trackingnummer og information på pakken.
                        </p>
                    </div>
                </div>
            </article>

            <RelatedArticlesComponent
                articles={[
                    {
                        "category": "udstyr",
                        "article": "kan-jeg-bruge-mit-eget-udstyr",
                        "name": "Kan jeg bruge mit eget udstyr?"
                    },
                    {
                        "category": "udstyr",
                        "article": "installationsmanual",
                        "name": "Sådan installerer du din router"
                    },
                    {
                        "category": "internet-og-wifi",
                        "article": "ip-adresse",
                        "name": "IP-adresse"
                    },
                    {
                        "category": "internet-og-wifi",
                        "article": "placering-af-router",
                        "name": "Tips til placering af router"
                    }
                ]}
            />
        </>
    )
}
